import { CommonModule } from '@angular/common';
import { APP_INITIALIZER, ModuleWithProviders, NgModule } from '@angular/core';

import { UnleashConfig } from './internal';
import { UnleashConfigToken } from './unleash-config';
import { UnleashDirective, UnleashNotDirective } from './unleash.directive';
import { UnleashService } from './unleash.service';

@NgModule({
	imports: [CommonModule],
	declarations: [UnleashDirective, UnleashNotDirective],
	exports: [UnleashDirective, UnleashNotDirective],
})
export class NgxUnleashProxyClientModule {
	static init(
		config: UnleashConfig
	): ModuleWithProviders<NgxUnleashProxyClientModule> {
		return {
			ngModule: NgxUnleashProxyClientModule,
			providers: [
				{ provide: UnleashConfigToken, useValue: config },
				{
					provide: APP_INITIALIZER,
					useFactory: (unleashService: UnleashService) => () =>
						unleashService.onInitialized,
					deps: [UnleashService],
					multi: true,
				},
			],
		};
	}
}
